import React, { useState } from 'react';
import PropTypes from 'prop-types';
import QuestionMarkIcon from '../../icons/components/QuestionMarkIcon';
import HandleClickOutside from '../../components/HandleClickOutside';
import './tool-tip.scss';
import CloseIcon from '../../icons/components/CloseIcon';

const ToolTip = ({ children, position, stopPropagation, className }) => {
  const [ showing, setShowing ] = useState(false);
  const contentClass = showing ?
    'tool-tip-content showing' : 'tool-tip-content';
  const content = (
    <div className={ contentClass }>
      <div className="triangle"></div>
      <CloseIcon testId="close-tool-tip" onClick={ () => setShowing(false) } />
      { children }
    </div>
  );
  let wrapperClass = typeof position !== 'undefined' ?
    `gbi-tool-tip ${position}` : 'gbi-tool-tip';
  if (className) wrapperClass += ' ' + className;
  const handleClick = event => {
    if (stopPropagation) event.stopPropagation();
  };
  return (
    <div className={ wrapperClass } onClick={ handleClick }>
      <HandleClickOutside handle={ () => setShowing(false) }>
        <div className="icon" onClick={ () => setShowing(!showing) }>
          <QuestionMarkIcon />
        </div>
        { content }
      </HandleClickOutside>
    </div>
  );
};

ToolTip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  position: PropTypes.oneOf(['left', 'right']),
  stopPropagation: PropTypes.bool,
  className: PropTypes.string
};

export default ToolTip;
